import React from "react"
import { Button } from "antd"
import ModalComponent from "../../../shared/components/Modals/ModalComponent"
import { ReactComponent as Microphone } from "../../../shared/assets/images/microphoneBlue.svg"
import { ReactComponent as Lightbulb } from "../../../shared/assets/images/Lightbulb.svg"
import { MicWarningModalProps } from "./types"



export const MicWarningModal: React.FC<MicWarningModalProps> = ({ visible, onClose }) => {
    return (
        <ModalComponent
            visibleModal={visible}
            handleCloseModal={onClose}
            title=""
            width={384}
            className="mic-warning-modal"
            content={
                <div className="flex flex-col items-center gap-6">
                    <div className="flex flex-col gap-5">
                        <div className="flex items-center justify-center w-12 h-12 mx-auto bg-indigo-100 rounded-full">
                            <Microphone className="w-6 h-6" />
                        </div>
                        <div className="flex flex-col items-center justify-center w-full gap-2">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">
                                Microphone Required
                            </h3>
                            <p className="text-sm leading-relaxed text-center text-gray-500">
                                Your microphone must be active before and throughout the interview to ensure clear communication and a smooth interview flow.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 px-[0.625rem] py-2 rounded-md bg-yellow-50">
                        <div>
                            <Lightbulb className="!w-5 !h-5" />
                        </div>
                        <p className="text-xs text-amber-800">
                            This helps our Al interviewer hear and respond to your answers accurately.
                        </p>
                    </div>
                    <Button
                        type="primary"
                        size="large"
                        onClick={onClose}
                        className="w-full !h-14 rounded-md bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium"
                    >
                        Ok
                    </Button>
                </div>
            }
        />
    )
}

